/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-03-29 11:22:56
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\components\inject\icons.ts
 */
import {
  AlipayCircleOutlined,
  CloseOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  EyeOutlined,
  FormOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  LockOutlined,
  MailOutlined,
  MailTwoTone,
  MobileOutlined,
  MobileTwoTone,
  PlusOutlined,
  RedoOutlined,
  RobotOutlined,
  RollbackOutlined,
  SafetyCertificateOutlined,
  TaobaoCircleOutlined,
  UserOutlined,
  WechatOutlined,
  WeiboCircleOutlined,
} from '@ant-design/icons';

export default {
  /** 加载 */
  LoadingOutlined,
  /** 邮箱 */
  MailTwoTone,
  /** 手机号 */
  MobileTwoTone,
  /** 表单 */
  FormOutlined,
  /** 添加 */
  PlusOutlined,
  /** 修改 */
  EditOutlined,
  /** 删除 */
  DeleteOutlined,
  /** 导出 */
  CloudDownloadOutlined,
  /** 导入 */
  CloudUploadOutlined,
  /** 用户头像 */
  UserOutlined,
  /** 眼睛 */
  EyeOutlined,
  AlipayCircleOutlined,
  TaobaoCircleOutlined,
  WeiboCircleOutlined,
  WechatOutlined,
  LockOutlined,
  MobileOutlined,
  SafetyCertificateOutlined,
  MailOutlined,
  InfoCircleOutlined,
  RedoOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  RollbackOutlined,
  EnvironmentOutlined,
  DownOutlined,
  ExportOutlined,
  RobotOutlined,
};
